import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Layout, Form, Button, Input, notification } from 'antd'
import { graphql } from 'react-apollo'

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import createProductMutation from '../graphql/mutations/createProduct'

import '../css/form.css'

const { Content } = Layout
const FormItem = Form.Item

class AddProduct extends Component {
  state = {
    submitting: false,
  }
  handleSubmit = async (e) => {
    e.preventDefault()
    this.setState({ submitting: true })
    const group = this.props.form.getFieldValue('group')
    const name = this.props.form.getFieldValue('name')
    const size = this.props.form.getFieldValue('size')
    const color = this.props.form.getFieldValue('color')
    const sku = this.props.form.getFieldValue('sku')
    const shirtId = this.props.form.getFieldValue('shirtId')
    const record = {
      group,
      name,
      size,
      color,
      sku,
      shirtId,
    }
    try {
      await this.props.createProduct({ variables: { record } })
      this.props.history.push('/products')
    } catch (err) {
      notification.error({
        message: 'Error',
        description: err.message,
      })
      this.setState({ submitting: false })
    }
  }
  handleInputChange = (e) => {
    this.props.form.setFieldsValue({ [e.target.name]: e.target.value })
  }
  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 4,
        },
      },
    }
    return (
      <Layout>
        <Navbar selected="product:2" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <Form onSubmit={this.handleSubmit}>
              <FormItem
                {...formItemLayout}
                label="Group"
              >
                {getFieldDecorator('group', {
                  initialValue: '',
                  rules: [{ required: true, message: 'Please input product group!' }],
                })(
                  <Input type="text" name="group" onChange={this.handleInputChange} />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="Name"
              >
                {getFieldDecorator('name', {
                  initialValue: '',
                  rules: [{ required: true, message: 'Please input product name!' }],
                })(
                  <Input type="text" name="name" onChange={this.handleInputChange} />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="Size"
              >
                {getFieldDecorator('size', {
                  initialValue: '',
                })(
                  <Input type="text" name="size" onChange={this.handleInputChange} />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="Color"
              >
                {getFieldDecorator('color', {
                  initialValue: '',
                })(
                  <Input type="text" name="color" onChange={this.handleInputChange} />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="Shop SKU"
              >
                {getFieldDecorator('sku', {
                  initialValue: '',
                })(
                  <Input type="text" name="sku" onChange={this.handleInputChange} />
                )}
              </FormItem>
              <FormItem
                {...formItemLayout}
                label="Race shirt ID"
              >
                {getFieldDecorator('shirtId', {
                  initialValue: '',
                })(
                  <Input type="text" name="shirtId" onChange={this.handleInputChange} />
                )}
              </FormItem>
              <FormItem {...tailFormItemLayout}>
                <Button type="primary" htmlType="submit" disabled={this.state.submitting}>Add product</Button>
              </FormItem>
            </Form>
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
AddProduct.propTypes = {
  form: PropTypes.shape(),
}
AddProduct.defaultProps = {
  form: {},
}

export default graphql(createProductMutation, { name: 'createProduct' })(Form.create()(AddProduct))



// WEBPACK FOOTER //
// ./src/pages/AddProduct.js